<template>
  <div class="mc-rec-ord-filters" role="tablist">
    <button
      v-for="opt in options"
      :key="opt.value"
      type="button"
      class="mc-rec-ord-filters__btn"
      :class="{ 'mc-rec-ord-filters__btn--active': value === opt.value }"
      role="tab"
      :aria-selected="value === opt.value"
      @click="$emit('input', opt.value)"
    >
      {{ opt.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'RecommendationOrderFilters',
  props: {
    value: { type: String, default: 'all' },
  },
  data() {
    return {
      options: [
        { value: 'all', label: 'Todos' },
        { value: 'converted', label: 'Apenas convertidos' },
        { value: 'recommended', label: 'Apenas recomendados' },
        { value: 'purchased', label: 'Apenas comprados' },
      ],
    }
  },
}
</script>
